/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Are you sure you want to delete this agent? This action cannot be undone.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Delete "{agentName}"?',
  'ai-mate.agent-list.delete-agent-error': 'Could not delete agent',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agent is currently in use. Try again later.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'That agent could not be found.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'You cannot delete agents you have not created yourself. Please contact the agent owner.',
  'ai-mate.agent-list.delete-agent-success': 'Agent has been deleted!',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Cancel',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Delete',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-selector.default-agent-description':
    'Get answers, generate new ideas, and accelerate everyday work. Write a prompt to get started.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - Copy',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Drag to reorder',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Could not save changes',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'An unknown error occurred. Please try again',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'An Agent with this name already exists',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Remove',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Generate conversation starters',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    "{fieldName} can't exceed {maxLength, plural, one {# character} other {# characters}}",
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Restart creation',
  'conversation-assistant-agent.create-agent.skip-to-configure-button-label': 'Skip to manual configuration',
  'rovo-chat.browse-agents.all-agents-button': 'All',
  'rovo-chat.browse-agents.close-button': 'Close',
  'rovo-chat.browse-agents.create-agent-button': 'Create',
  'rovo-chat.browse-agents.create-an-agent-button': 'Create an agent',
  'rovo-chat.browse-agents.created-by-label': '<text>by</text> {creatorName}',
  'rovo-chat.browse-agents.favourited-agent-label': 'Favorited agent',
  'rovo-chat.browse-agents.learn-more': 'Learn more',
  'rovo-chat.browse-agents.modal-title': 'Browse agents',
  'rovo-chat.browse-agents.more-actions-label': 'More actions',
  'rovo-chat.browse-agents.my-agents-button': 'My agents',
  'rovo-chat.browse-agents.no-created-agents':
    "It looks like you haven't created any agents yet. Start by duplicating other existing agents or begin from scratch to create one.",
  'rovo-chat.browse-agents.no-created-agents-header': 'No agents created yet',
  'rovo-chat.browse-agents.no-results': 'No results',
  'rovo-chat.browse-agents.search-input.placeholder': 'Search agents',
  'rovo-chat.browse-agents.starred-agents-button': 'Starred',
  'rovo-chat.create-agent.all-content-label': 'All content',
  'rovo-chat.create-agent.all-spaces-label': 'All spaces',
  'rovo-chat.create-agent.back-button': 'Go back',
  'rovo-chat.create-agent.confirm-leave-modal.body': "You haven't created your Agent yet, do you want to discard it?",
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Cancel',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Yes, discard Agent',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Unfinished Agent',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Are you sure you want to discard all existing information and restart the creation of your Agent?',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Restart creation',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'People can use these to start a chat with your Agent. If you can’t think of any, we can generate them for you.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Conversation starters',
  'rovo-chat.create-agent.create-agent-button': 'Create',
  'rovo-chat.create-agent.description-field-description':
    "People can use the description on the Agent's profile to learn more about it.",
  'rovo-chat.create-agent.description-field-label': 'Description',
  'rovo-chat.create-agent.description-field-placeholder':
    'Write a short description about your Agent (for example, creative writer for marketing blogs)',
  'rovo-chat.create-agent.instructions-field-description':
    'How do you want this Agent to behave? What can it do? <link>More on writing instructions for an Agent</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Instructions',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Customize the instructions for this Agent',
  'rovo-chat.create-agent.knowledge-field-description':
    "Specify the Agent's knowledge by only allowing it to reference the sources you provide",
  'rovo-chat.create-agent.knowledge-field-label': 'Knowledge',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Only reference these sources',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Suggested',
  'rovo-chat.create-agent.name-field-description': 'People can use this to find the Agent.',
  'rovo-chat.create-agent.name-field-label': 'Name',
  'rovo-chat.create-agent.name-field-placeholder': 'Name your Agent',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Type your message',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Send',
  'rovo-chat.create-agent.page-title': 'Create an Agent',
  'rovo-chat.create-agent.page-title-edit': 'Edit Agent',
  'rovo-chat.create-agent.publish-option.hide-agent-description': "Won't show in search results.",
  'rovo-chat.create-agent.publish-option.hide-agent-label': 'Hide Agent',
  'rovo-chat.create-agent.publish-option.show-agent-description': 'Available to everyone on this site.',
  'rovo-chat.create-agent.publish-option.show-agent-label': 'Show Agent',
  'rovo-chat.create-agent.update-agent-button': 'Update',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    "If you continue, you'll lose unsaved changes. Select Cancel to continue editing this Agent.",
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Continue, discard changes',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Discard changes',
  'rovo-chat.view-agent.about-label': 'About',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chat to agent',
  'rovo-chat.view-agent.close-button': 'Close',
  'rovo-chat.view-agent.copy-instructions-label': 'Copy',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Copy response',
  'rovo-chat.view-agent.copy-link-to-profile': 'Copy link',
  'rovo-chat.view-agent.created-by-label': '<text>by</text> {agentName}',
  'rovo-chat.view-agent.delete-agent': 'Delete agent',
  'rovo-chat.view-agent.duplicate-agent': 'Duplicate agent',
  'rovo-chat.view-agent.edit-agent': 'Edit agent',
  'rovo-chat.view-agent.favourites-metadata-label': '# of favorites',
  'rovo-chat.view-agent.go-back-label': 'Go back',
  'rovo-chat.view-agent.instructions-label': 'Instructions',
  'rovo-chat.view-agent.knowledge-label': 'Knowledge',
  'rovo-chat.view-agent.link-copied-to-profile': 'Copied URL',
  'rovo-chat.view-agent.modal-title': 'Browse Agents',
  'rovo-chat.view-agent.more-actions-label': 'More actions',
  'rovo-chat.view-agent.no-instruction-placeholder': 'This Agent has no custom instructions',
  'rovo-chat.view-agent.no-knowledge-added': 'No custom knowledge sources',
  'rovo-chat.view-agent.open-chat-label': 'Open chat',
  'rovo-chat.view-agent.reactions-metadata-label': '# of reactions',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo Agent',
  'rovo-chat.view-agent.users-metadata-label': '# of users',
  'rovo-chat.view-agents.view-agent': 'View agent',
};
